import * as React from "react";
import {
  getDeploymentStatusMeta,
  getServiceStatusMeta,
  toneClasses,
} from "../../lib/statusMeta";
import { cn } from "../../lib/utils";
import { DeploymentStatus, ServiceStatus } from "../../types";

type Common = {
  showIcon?: boolean;
  className?: string;
};

type StatusBadgeProps =
  | (Common & { kind: "deployment"; status: DeploymentStatus | string })
  | (Common & { kind: "service"; status: ServiceStatus | string });

export function StatusBadge(props: StatusBadgeProps) {
  const { className, showIcon = true } = props;
  const meta =
    props.kind === "deployment"
      ? getDeploymentStatusMeta(props.status)
      : getServiceStatusMeta(props.status);

  const Icon = meta.icon;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
        toneClasses(meta.tone),
        className
      )}
      title={meta.description}
    >
      {showIcon && (
        <Icon
          className={cn("h-3 w-3", meta.pulse && "animate-pulse")}
          aria-hidden="true"
        />
      )}
      <span>{meta.label}</span>
    </span>
  );
}
